"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const strings_1 = require("../../../../../constants/strings");
const codingQuery_1 = require("../../../../../queries/codingQuery");
const zustandStore_1 = require("../../../../../zustandStore");
const populateSelectedCodingEntryTeams_1 = require("./populateSelectedCodingEntryTeams");
const logger = (0, pino_1.default)();
let initialCodingEntryId = '';
let initialCodingEntryPath = '';
const useGetTableData = ({ teams, selectedCodingEntries }) => {
    const { setIsCodingListSelectorAsideOpen, setCurrentSelectedCodingEntry, setCurrentSelectedCodingEntryTeams, setIsRemoveCodingEntryAsideOpen, setIsNewEntryAsideOpen, setNotification, } = (0, zustandStore_1.useZustand)();
    const selectedCodingList = (0, zustandStore_1.useZustand)(state => state.codingList.currentCodingListSelected);
    const changeCodingListEntryId = (0, codingQuery_1.useChangeCodingListEntryIdQuery)();
    const toggleCodingListEntryQuery = (0, codingQuery_1.useToggleCodingListEntryQuery)();
    const saveCodingListEntry = (0, codingQuery_1.useSaveCodingListEntryQuery)();
    const company = (0, zustandStore_1.useZustand)(state => state.company);
    const currentCodingEntryTeams = (0, zustandStore_1.useZustand)(state => state.codingEntry.currentCodingEntryTeams);
    const { data: codingInactiveListEntries, isFetching: isCodingInactiveListEntriesLoading } = (0, codingQuery_1.useGetInactiveCodingListEntriesQuery)({
        companyId: company?.companyId,
    });
    const [isMutationInProgress, setIsMutationInProgress] = (0, react_1.useState)(false);
    const selectedCodingEntriesValues = structuredClone(selectedCodingEntries) || [
        { code: '', values: [{ Id: '', path: '' }] },
    ];
    return [
        selectedCodingEntriesValues.map((entry, index) => {
            const selectedTeams = [];
            const currentSelectedEntryValue = structuredClone(selectedCodingEntriesValues[index]);
            if (codingInactiveListEntries) {
                teams.forEach((team) => {
                    const inactiveEntries = codingInactiveListEntries?.[selectedCodingList.id] || [];
                    const teamHasInactiveEntry = inactiveEntries.find(inactiveEntry => inactiveEntry.entry_id === entry.ID && inactiveEntry.team_id === team.id);
                    if (!teamHasInactiveEntry) {
                        selectedTeams.push(team.name);
                    }
                });
            }
            return {
                id: `${entry.ID}${index}`,
                entryId: {
                    text: entry.ID,
                    onFocus(event) {
                        // save current entry before changing
                        initialCodingEntryId = entry.ID;
                        if (!currentSelectedEntryValue) {
                            return;
                        }
                        currentSelectedEntryValue.ID = event.target.value;
                    },
                    onBlur(event) {
                        if (event.target.value === initialCodingEntryId) {
                            initialCodingEntryId = '';
                            return;
                        }
                        else if (selectedCodingEntries.some(entry => entry.ID === event.target.value)) {
                            const warningMessage = strings_1.companySettingsCodingStrings.CODING_ENTRY_DUPLICATE_ERROR({
                                entryId: event.target.value,
                            });
                            setNotification([
                                {
                                    type: strings_1.notificationStrings.WARNING,
                                    message: warningMessage,
                                },
                            ]);
                            return;
                        }
                        setIsMutationInProgress(true);
                        changeCodingListEntryId.mutate({
                            codingListCode: selectedCodingList.id,
                            codingEntryId: initialCodingEntryId,
                            newCodingEntryId: event.target.value,
                            codingEntryLabel: entry.path,
                        }, {
                            onSuccess: () => {
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.SUCCESS,
                                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_SUCCESS,
                                    },
                                ]);
                            },
                            onError: error => {
                                logger.error({ error });
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.ERROR,
                                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_ERROR,
                                    },
                                ]);
                            },
                            onSettled: () => {
                                setIsMutationInProgress(false);
                            },
                        });
                        initialCodingEntryId = '';
                        currentCodingEntryTeams.forEach((entry) => {
                            toggleCodingListEntryQuery.mutate({
                                codingListCode: selectedCodingList.id,
                                codingEntryId: event.target.value,
                                teamId: entry.teamId,
                                state: entry.state,
                            });
                        });
                    },
                },
                entryPath: {
                    text: entry.path,
                    onFocus(event) {
                        // save current entry before changing
                        initialCodingEntryPath = entry.path;
                        if (!currentSelectedEntryValue) {
                            return;
                        }
                        currentSelectedEntryValue.path = event.target.value;
                    },
                    onBlur(event) {
                        if (event.target.value === initialCodingEntryPath) {
                            initialCodingEntryPath = '';
                            return;
                        }
                        setIsMutationInProgress(true);
                        saveCodingListEntry.mutate({
                            codingListCode: selectedCodingList.id,
                            codingEntryId: entry.ID,
                            codingEntryLabel: event.target.value,
                        }, {
                            onSuccess: () => {
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.SUCCESS,
                                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_SUCCESS,
                                    },
                                ]);
                            },
                            onError: error => {
                                logger.error({ error });
                                setNotification([
                                    {
                                        type: strings_1.notificationStrings.ERROR,
                                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_ERROR,
                                    },
                                ]);
                            },
                            onSettled: () => {
                                setIsMutationInProgress(false);
                            },
                        });
                        initialCodingEntryPath = '';
                    },
                },
                entryTeams: isCodingInactiveListEntriesLoading
                    ? 'Loading...'
                    : selectedTeams.length === teams.length
                        ? strings_1.companySettingsCodingStrings.CHANGE_TEAM_ASIDE_ALL_TEAMS_OPTION
                        : selectedTeams.reduce((string, team) => {
                            return string === '' ? team : `${string}, ${team}`;
                        }, ''),
                teamState: {
                    onClick() {
                        setIsNewEntryAsideOpen(false);
                        setCurrentSelectedCodingEntry(entry);
                        (0, populateSelectedCodingEntryTeams_1.populateSelectedCodingEntryTeams)({
                            selectedCodingList,
                            setCurrentSelectedCodingEntryTeams,
                            teams,
                            codingInactiveListEntries,
                            codingEntry: entry,
                        });
                        setIsCodingListSelectorAsideOpen(true);
                    },
                },
                rowActions: {
                    tsVariant: 'tsIcon',
                    startIcon: (0, jsx_runtime_1.jsx)("i", { className: "ts-icon-remove ts-color-dark" }),
                    onClick() {
                        setCurrentSelectedCodingEntry(entry);
                        setIsRemoveCodingEntryAsideOpen(true);
                    },
                },
            };
        }),
        isMutationInProgress,
    ];
};
exports.useGetTableData = useGetTableData;
